export const cdnUrls = {
  images: {
    header:
      "https://cdn.api.auping.com/sites/default/files/2023-05/Optie%201%20headerbeeld%20(1).jpg",
    "physical-complaints":
      "https://cdn.api.auping.com/sites/default/files/2023-05/Lichamelijke%20klachten%20(1).jpg",
    "new-bed":
      "https://cdn.api.auping.com/sites/default/files/2023-05/Beeld%20configurator%20V2%20(1).jpg",
  },
};